<template>
  <div class="m-right-nav">
    <div class="m-right-item" @click="showTelDialog">
      <img class="m-right-icon" src="../../../assets/images/icon_phone.png" alt="">
    </div>
    <a class="m-right-item" onclick="window.open('http://chat32.live800.com/live800/chatClient/chatbox.jsp?companyID=138747&jid=9767903609&configID=23526&enterurl=http://chat32.live800.com:8080/live800/preview.jsp','','height=500,width=650,directories=no,status=no,menubar=no,scrollbars=no')">
      <img class="m-right-icon" src="../../../assets/images/icon_connect.png" alt="">
    </a>
    <!-- <div class="m-right-item" @click="goFenxiao">
      <img class="m-right-icon" src="../../../assets/images/icon_school.png" alt="">
    </div> -->
    <div :class="topFlag ? 'showTop' : 'hideTop'" class="m-right-item back-top" @click="backtop">
      <img class="m-right-icon" src="../../../assets/images/icon_top.png" alt="">
    </div>
    <!-- 电话弹窗 -->
    <div class="m-dialog" v-if="showDialog">
      <div class="m-dialog-wrap">
        <div class="m-dialog-content">
          <p class="m-dialog-title">联系电话</p>
          <div class="m-phone-item">400-061-6167</div>
        </div>
        <img @click="closeApplyDialog" class="m-close-btn" src="../../../assets/images/mImg/home/close-dialog.png" alt="">
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      topFlag: false,
      showTel: false,
      showOnline: false,
      showFenxiao: false,
      showDialog: false
    }
  },
  mounted(){
    window.addEventListener("scroll",this.showbtn,true);
  },
  methods: {
    showTelDialog() {
      this.showDialog=true
      document.body.style.overflow='hidden'
    },
    closeApplyDialog() {
      this.showDialog = false
      document.body.style.overflow=''
    },
    goFenxiao() {
      let url = this.$router.resolve({
        path: '/mett/fx'
      })
      window.open(url.href, '_blank')
    },
    showbtn(){
      let that = this;
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      that.scrollTop = scrollTop
      if (that.scrollTop > document.documentElement.clientHeight) {
          that.topFlag = true
      } else {
          that.topFlag = false
      }
    },
    // 回到顶部
    backtop(){
      let timer = setInterval(function(){
        let osTop = document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 5); 
        document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
        // this.isTop = true;
        if(osTop === 0){
          clearInterval(timer);
        }
      },30)
    },
  }
}
</script>
<style lang="scss" scoped>
.m-right-nav {
  position: fixed;
  right: 0;
  top: 50%;
  border-radius: .1rem 0px 0px .1rem;
  z-index: 100;
  .m-right-item {
    position: relative;
    display: block;
    width: .8rem;
    height: .8rem;
    background: #2E96FF;
    border-top: 1px solid rgba(255, 255, 255, .3);
    line-height: .8rem;
    .m-right-icon {
      width: .44rem;
      height: .44rem;
      display: block;
      margin: 0 auto;
      margin-top: .18rem;
    }
  }
  .hideTop {
    transition: opacity .5s;
    opacity: 0;
  }
  .showTop {
    transition: opacity .5s;
    opacity: 1;
  }
  .m-dialog {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, .5);
    z-index: 999;
    .m-dialog-wrap {
      width: 100%;
      padding: 0 .56rem;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    .m-dialog-content {
      padding: .42rem 0 .48rem;
      background: #FFFFFF;
      border-radius: .2rem;
      .m-dialog-title {
        font-size: .4rem;
        font-weight: 500;
        color: #333333;
        line-height: .6rem;
        text-align: center;
      }
    }
    .m-phone-item {
      font-size: .3rem;
      font-weight: 400;
      color: #666666;
      line-height: .36rem;
      margin-top: .24rem;
      text-align: center;
    }
    .m-close-btn {
      width: .9rem;
      height: .9rem;
      display: block;
      margin: 0 auto;
      margin-top: .4rem;
    }
  }
}
</style>